<template>
  <div>
    <div class="bg-white py-6">
      <!-- Replace with your content -->
      <div>
        <div class="md:flex md:items-center md:justify-between sm:px-6 md:px-8">
          <div class="flex-1 min-w-0">
            <h2 class="text-2xl font-bold leading-7 text-gray-800 sm:text-3xl sm:truncate">
              {{ $t("messages.affiliatePayout.affiliatePayout") }}
            </h2>
          </div>
        </div>
      </div>
    </div>
    <!-- /End replace -->
    <nav class="bg-white border-b border-t border-gray-200 flex" aria-label="Breadcrumb">
      <ol class="w-full mx-auto px-4 flex space-x-4 sm:px-6 md:px-8">
        <li class="flex">
          <div class="flex items-center">
            <a href="javascript:void(0)" class="text-gray-400 hover:text-gray-500">
              <HomeIcon class="flex-shrink-0 h-5 w-5" aria-hidden="true" />
              <span class="sr-only">Home</span>
            </a>
          </div>
        </li>
        <li v-for="page in pages" :key="page.name" class="flex">
          <div class="flex items-center">
            <svg class="flex-shrink-0 w-6 h-full text-gray-200" viewBox="0 0 24 44" preserveAspectRatio="none"
              fill="currentColor" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
              <path d="M.293 0l22 22-22 22h1.414l22-22-22-22H.293z" />
            </svg>
            <router-link :to="page.href" class="ml-4 text-sm font-medium text-gray-500 hover:text-gray-700"
              :aria-current="page.current ? 'page' : undefined">{{ page.name }}</router-link>
          </div>
        </li>
      </ol>
    </nav>
    <div class="md:flex md:items-center md:justify-between bg-white border-b border-gray-200 flex py-4 pl-8">
      <div class="max-w-lg w-56 lg:max-w-xs">
        <label for="search" class="sr-only">Search</label>
        <div class="relative text-gray-400 focus-within:text-gray-600">
          <div class="pointer-events-none absolute inset-y-0 pl-3 left-0 flex items-center">
            <SearchIcon class="h-5 w-5" aria-hidden="true" />
          </div>
          <input id="search" v-model="searchInput"
            class="block w-full bg-white py-2 pl-10 focus:bg-white pr-3 border border-transparent rounded-md leading-5 text-gray-900 placeholder-gray-500 focus:ring-offset-blue-600 focus:ring-white focus:border-white sm:text-sm"
            type="search" name="search" :placeholder="$t('messages.affiliatePayout.search')"
            @input="searchText($event)" />
        </div>
      </div>
      <div class="mt-4 flex-shrink-0 flex md:mt-0 md:ml-4 pr-8">
        <button type="button" @click="filterModal"
          class="ml-3 inline-flex items-center px-3 py-1 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-500 hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-white focus:ring-blue-500">
          <font-awesome-icon class="text-white mr-2" :icon="['far', 'filter']" transform="" />
          {{ $t("messages.affiliatePayout.advanceFilter") }}
        </button>
      </div>
    </div>

    <!-- <div class="px-8 py-6" v-show="!isLoaded">
      <div
        class="space-y-8 divide-y divide-gray-200 bg-white px-10 py-9 rounded-md shadow-md text-center"
      >
        <font-awesome-icon
          class="text-gray-500"
          :icon="['fas', 'circle-notch']"
          transform="grow-6"
          spin
        />
      </div>
    </div> -->

    <div class="relative py-6">
      <div class="sm:px-6 md:px-8">
        <div class="bg-white shadow sm:rounded-md">
          <div class="shadow overflow-x-auto border-b border-gray-200 sm:rounded-t-lg">
            <div v-if="!isLoaded"
              class="absolute inset-0 bg-gray-100 bg-opacity-75 flex justify-center items-center z-50">
              <div class="loader"></div>
              <p class="text-gray-700 text-lg">Loading...</p>
            </div>
            <table class="table min-w-full divide-y divide-gray-200">
              <thead class="bg-gray-50">
                <tr>
                  <th scope="col"
                    class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    {{ $t("messages.affiliatePayout.accountName") }}
                  </th>
                  <th scope="col"
                    class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    {{ $t("messages.affiliatePayout.phoneNumber") }}
                  </th>
                  <th @click="doSort('amount')" scope="col"
                    class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider text-right cursor-pointer">
                    {{ $t("messages.affiliatePayout.amount") }}
                    <font-awesome-icon :icon="['fas', sort.amount ? 'arrow-down' : 'arrow-up']" />
                  </th>
                  <th @click="doSort('requestDate')" scope="col"
                    class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider text-right cursor-pointer">
                    {{ $t("messages.affiliatePayout.requestedDate") }}

                    <font-awesome-icon :icon="[
                      'fas',
                      sort.requestDate ? 'arrow-up' : 'arrow-down',
                    ]" />
                  </th>
                  <th @click="doSort('startDate')" scope="col"
                    class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider text-right cursor-pointer">
                    {{ $t("messages.affiliatePayout.startDate") }}

                    <font-awesome-icon :icon="[
                      'fas',
                      sort.start_date ? 'arrow-up' : 'arrow-down',
                    ]" />
                  </th>
                  <th @click="doSort('endDate')" scope="col"
                    class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider text-right cursor-pointer">
                    {{ $t("messages.affiliatePayout.endDate") }}

                    <font-awesome-icon :icon="['fas', sort.end_date ? 'arrow-up' : 'arrow-down']" />
                  </th>
                  <th scope="col"
                    class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider text-right">
                    {{ $t("messages.affiliatePayout.status") }}
                  </th>
                  <th scope="col"
                    class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider text-right">
                    {{ $t("messages.affiliatePayout.approvedBy") }}
                  </th>
                  <th scope="col"
                    class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider text-right">
                  </th>
                </tr>
              </thead>
              <tbody class="bg-white divide-y divide-gray-200 overflow-x-scroll">
                <tr v-for="data in dataRows" :key="data.id" class="hover:bg-gray-50">
                  <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500" style="color: #4169e1">
                    {{ data.account_name }}
                  </td>
                  <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                    {{ data.affiliate.username }}
                  </td>
                  <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500 text-right" :style="parseFloat(data.total / 100) >= 0
                      ? { color: 'green' }
                      : { color: 'red' }
                    ">
                    {{
                      parseFloat(data.total / 100).toLocaleString("en", {
                        useGrouping: true,
                        minimumFractionDigits: 2,
                      })
                    }}
                  </td>
                  <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500 text-right">
                    {{ getLocaleDate(data.created_at) }}
                  </td>
                  <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500 text-right">
                    {{ getLocaleDate(data.start_date) }}
                  </td>
                  <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500 text-right">
                    {{ getLocaleDate(data.end_date) }}
                  </td>
                  <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500 text-right">
                    <span v-if="data.status == 'UNPAID'"
                      class="inline-block text-xs py-1 px-2 rounded-lg bg-yellow-500 text-white">{{ data.status
                      }}</span>
                    <span v-else-if="data.status == 'PAID'"
                      class="inline-block text-xs py-1 px-2 rounded-lg bg-green-500 text-white">{{ data.status }}</span>
                    <span v-else class="inline-block text-xs py-1 px-2 rounded-lg bg-red-500 text-white">{{ data.status
                      }}</span>
                  </td>
                  <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500 text-right">
                    {{ data.approved_by || "-" }}
                  </td>
                  <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500 text-right cursor-pointer">
                    <DropdownButton v-if="
                      data.status === 'UNPAID' &&
                      store.state.user.permissions.includes(
                        'AFFILIATE.APPROVE_PAYMENT'
                      ) &&
                      !isWorking
                    " type="affiliate payout" :children="buttonDropDownConfig.children" :data="data"
                      :title="buttonDropDownConfig.title" />
                    <!-- <button
                      type="button"
                      href="javascript:void(0)"
                      @click="
                        data.status == 'UNPAID' &&
                          !isWorking &&
                          approvePayout(data.id)
                      "
                      v-if="
                        store.state.user.permissions.includes(
                          'AFFILIATE.APPROVE_PAYMENT'
                        )
                      "
                      :disabled="data.status !== 'UNPAID' && isWorking"
                      class="inline-flex items-center px-3 py-1 border border-transparent rounded-md shadow-sm text-sm font-medium text-white"
                      :style="data.status !== 'UNPAID' ? { opacity: 0.5 } : ''"
                      :class="
                        data.status !== 'UNPAID'
                          ? 'hidden bg-green-500 cursor-auto'
                          : 'bg-red-500 hover:bg-red-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-white focus:ring-red-600'
                      "
                    >
                      <font-awesome-icon
                        class="text-gray-500"
                        :icon="['fas', 'circle-notch']"
                        transform="grow-6"
                        spin
                        v-if="isWorking"
                      />
                      <p v-else>
                        {{
                          data.status !== "UNPAID"
                            ? $t("messages.affiliatePayout.approved")
                            : $t("messages.affiliatePayout.approve")
                        }}
                      </p>
                    </button> -->
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div
            class="bg-white px-4 py-3 flex items-center justify-between border-t rounded-b-lg border-gray-200 sm:px-6">
            <div class="hidden sm:flex-1 sm:flex sm:items-center sm:justify-between">
              <div>
                <Listbox as="div" v-model="rowsPerPage">
                  <ListboxButton
                    class="bg-white relative w-full border border-gray-300 rounded-md shadow-sm pl-3 pr-10 py-2 text-left cursor-default focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm">
                    <span class="block truncate">{{ rowsPerPage.value }}</span>
                    <span class="absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none">
                      <SelectorIcon class="h-5 w-5 text-gray-400" aria-hidden="true" />
                    </span>
                  </ListboxButton>
                  <ListboxOptions
                    class="absolute z-10 mt-1 w-44 bg-white shadow-lg max-h-60 rounded-md py-1 text-base ring-1 ring-black ring-opacity-5 overflow-auto focus:outline-none sm:text-sm">
                    <ListboxOption as="template" v-for="(option, index) in rowsPerPageOption" :key="index"
                      :value="option" @click="refetch">
                      <li :class="[
                        'hover:text-white hover:bg-indigo-600 text-gray-900 cursor-default select-none relative py-2 pl-3 pr-9',
                      ]">
                        <span :class="[
                          option.value == rowsPerPageOption.value
                            ? 'font-semibold'
                            : 'font-normal',
                          'block truncate text-left',
                        ]">
                          {{ option.label }}
                        </span>

                        <span v-if="option.value == rowsPerPageOption.value" :class="[
                          'absolute inset-y-0 right-0 flex items-center pr-4 pl-5',
                        ]">
                          <CheckIcon class="h-5 w-5" aria-hidden="true" />
                        </span>
                      </li>
                    </ListboxOption>
                  </ListboxOptions>
                </Listbox>
              </div>
            </div>
            <div>
              <nav class="relative z-0 inline-flex rounded-md shadow-sm -space-x-px" aria-label="Pagination">
                <!-- <a
                  href="javascript:void(0)"
                  @click="jump(1)"
                  class="relative inline-flex items-center px-2 py-2 rounded-l-md border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50"
                >
                  <span class="sr-only">First</span>
                  <span class="h-5 w-5 text-center"
                    ><font-awesome-icon
                      class="text-gray-500"
                      :icon="['fas', 'chevron-double-left']"
                      transform="shrink-2"
                  /></span>
                </a> -->
                <a href="javascript:void(0)" @click="prev"
                  class="relative inline-flex items-center px-2 py-2 border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50">
                  <span class="sr-only">Previous</span>
                  <span class="h-5 w-5 text-center"><font-awesome-icon class="text-gray-500"
                      :icon="['fas', 'chevron-left']" transform="shrink-2" /></span>
                </a>
                <span href="javascript:void(0)" @click="prev"
                  class="relative inline-flex items-center px-4 py-2 border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50">
                  {{ currentPage }}
                </span>
                <a href="javascript:void(0)" @click="next"
                  class="relative inline-flex items-center px-2 py-2 border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50">
                  <span class="sr-only">Next</span>
                  <span class="h-5 w-5 text-center"><font-awesome-icon class="text-gray-500"
                      :icon="['fas', 'chevron-right']" transform="shrink-2" /></span>
                </a>
                <!-- <a
                  href="javascript:void(0)"
                  @click="jump(Math.ceil(dataCount / rowsPerPage.value))"
                  class="relative inline-flex items-center px-2 py-2 rounded-r-md border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50"
                >
                  <span class="sr-only">Last</span>
                  <span class="h-5 w-5 text-center"
                    ><font-awesome-icon
                      class="text-gray-500"
                      :icon="['fas', 'chevron-double-right']"
                      transform="shrink-2"
                  /></span>
                </a> -->
              </nav>
            </div>
          </div>
        </div>
      </div>
    </div>

    <TransitionRoot as="template" :show="advanceFilterModal">
      <Dialog as="div" static class="fixed z-10 inset-0 overflow-y-auto" @close="advanceFilterModal = false"
        :open="advanceFilterModal">
        <div class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
          <TransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0" enter-to="opacity-100"
            leave="ease-in duration-200" leave-from="opacity-100" leave-to="opacity-0">
            <DialogOverlay class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
          </TransitionChild>

          <!-- This element is to trick the browser into centering the modal contents. -->
          <span class="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>
          <TransitionChild as="template" enter="ease-out duration-300"
            enter-from="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            enter-to="opacity-100 translate-y-0 sm:scale-100" leave="ease-in duration-200"
            leave-from="opacity-100 translate-y-0 sm:scale-100"
            leave-to="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95">
            <div
              class="inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-md sm:w-full sm:p-6">
              <div>
                <div class="mt-2 text-center sm:mt-5">
                  <DialogTitle as="h3" class="text-lg leading-6 font-medium text-gray-900">
                    {{ $t("messages.affiliatePayout.advanceFilter") }}

                    <!-- <small class="text-gray-400">{{ userInfo.username }}</small> -->
                  </DialogTitle>
                  <div class="rounded-md bg-red-50 p-4 text-left mt-3" v-show="hasError">
                    <div class="flex">
                      <div class="flex-shrink-0">
                        <XCircleIcon class="h-5 w-5 text-red-400" aria-hidden="true" />
                      </div>
                      <div class="ml-3">
                        <h3 class="text-sm font-medium text-red-800">
                          {{ errorMessage }}
                        </h3>
                      </div>
                    </div>
                  </div>

                  <div class="mt-6 pb-2 text-left">
                    <label class="text-sm">{{
                      $t("messages.affiliatePayout.status")
                    }}</label>
                    <div class="mt-1">
                      <select id="actionFillter" name="actionFillter" v-model="filterForm.status"
                        class="capitalize mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm rounded-md">
                        <option v-for="status in status_list" :key="status.id" :value="status.val">
                          {{ status.val }}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
              <div class="mt-5 sm:mt-6 sm:grid sm:grid-cols-2 sm:gap-3 sm:grid-flow-row-dense">
                <button type="button" @click="filterModal(1)"
                  class="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-blue-600 text-base font-medium text-white hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 sm:col-start-2 sm:text-sm">
                  Filter
                </button>
                <button type="button" @click="filterModal()"
                  class="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 sm:mt-0 sm:col-start-1 sm:text-sm"
                  ref="cancelButtonRef">
                  Cancel
                </button>
              </div>
            </div>
          </TransitionChild>
        </div>
      </Dialog>
    </TransitionRoot>
  </div>
</template>

<script>
import {
  CheckCircleIcon,
  ChevronLeftIcon,
  ChevronRightIcon,
  MailIcon,
  HomeIcon,
  SearchIcon,
  CheckIcon,
  SelectorIcon,
  XCircleIcon,
} from "@heroicons/vue/solid";
import {
  Listbox,
  ListboxButton,
  ListboxLabel,
  ListboxOption,
  DialogOverlay,
  TransitionChild,
  DialogTitle,
  ListboxOptions,
  Dialog,
  TransitionRoot,
} from "@headlessui/vue";
import { inject, onMounted, ref } from "@vue/runtime-core";
import { useStore } from "vuex";
import * as dayjs from "dayjs";
import "dayjs/locale/th";
import localizedFormat from "dayjs/plugin/localizedFormat";
import { useRoute, useRouter } from "vue-router";
import { translate } from "@/utils/tools";
import DropdownButton from "@/components/tools/DropdownButton.vue";

dayjs.extend(localizedFormat);

const pages = [{ name: "Affiliate Payout", href: "", current: true }];

const rowsPerPageOption = [
  { label: "2", value: 2 },
  { label: "5", value: 5 },
  { label: "10", value: 10 },
  { label: "20", value: 20 },
  { label: "30", value: 30 },
  { label: "40", value: 40 },
];

export default {
  components: {
    ChevronLeftIcon,
    ChevronRightIcon,
    CheckCircleIcon,
    MailIcon,
    HomeIcon,
    SearchIcon,
    CheckIcon,
    SelectorIcon,
    DialogOverlay,
    TransitionChild,
    DialogTitle,
    Listbox,
    ListboxButton,
    ListboxLabel,
    ListboxOption,
    ListboxOptions,
    XCircleIcon,
    Dialog,
    TransitionRoot,
    DropdownButton,
  },
  setup() {
    const axios = inject("$axios");
    const store = useStore();
    const router = useRouter();
    const route = useRoute();
    const searchInput = ref("");
    const currentPage = ref(1);
    const offset = ref(0);
    const rowsPerPage = ref({ label: "10", value: 10 });
    const sort = ref({
      requestDate: false,
      amount: false,
    });
    const orderBy = ref(["created_at", "DESC"]);
    const buttonDropDownConfig = ref({
      title: "Approve/Reject",
      children: [
        {
          label: "Approve",
          isConfirm: true,
          class: "",
          action: async (data) => {
            await approvePayout(data.id, "PAID");
          },
        },
        {
          label: "Reject & Refund",
          isConfirm: true,
          class: "",
          action: async (data) => {
            await approvePayout(data.id, "REJECT_REFUND");
          },
        },
        {
          label: "Reject with No Refund",
          isConfirm: true,
          class: "",
          action: async (data) => {
            await approvePayout(data.id, "REJECT_NON_REFUND");
          },
        },
      ],
    });

    let dataRows = ref([]);
    let dataCount = ref(0);
    let isLoaded = ref(false);
    let currentDate = ref(
      route.query.date || new Date().toISOString().split("T")[0]
    );
    const isWorking = ref(false);
    let advanceFilterModal = ref(false);

    let errorMessage = ref("");

    let filterForm = ref({
      status: `-${translate(
        "messages.affiliatePayout.selectStatus"
      )}-`.toUpperCase(),
    });

    let hasError = ref(false);

    let status_list = [
      {
        id: 0,
        val: `-${translate(
          "messages.affiliatePayout.selectStatus"
        )}-`.toUpperCase(),
      },
      {
        id: 1,
        val: "PAID",
      },
      {
        id: 2,
        val: "UNPAID",
      },
      {
        id: 3,
        val: "REJECT_REFUND",
      },
      {
        id: 4,
        val: "REJECT_NON_REFUND",
      },
    ];

    onMounted(() => {
      refetch(currentDate.value);
    });

    const doSort = (key) => {
      sort.value[key] = !sort.value[key];
      if (sort.value[key]) {
        if (key === "requestDate") {
          orderBy.value = ["created_at", "ASC"];
        }
        if (key === "amount") {
          orderBy.value = ["total", "DESC"];
        }
        if (key === "startDate") {
          orderBy.value = ["start_date", "ASC"];
        }
        if (key === "endDate") {
          orderBy.value = ["end_date", "ASC"];
        }
      } else {
        if (key === "requestDate") {
          orderBy.value = ["created_at", "DESC"];
        }
        if (key === "amount") {
          orderBy.value = ["total", "ASC"];
        }
        if (key === "startDate") {
          orderBy.value = ["start_date", "DESC"];
        }
        if (key === "endDate") {
          orderBy.value = ["end_date", "DESC"];
        }
      }
      refetch();
    };

    const filterModal = (flag = false) => {
      advanceFilterModal.value = !advanceFilterModal.value;

      if (flag == 1) filterData(1);
    };

    const searchText = () => {
      if (searchInput.value !== "") {
        currentPage.value = 1;
        offset.value = 0;
        axios
          .post(
            `${process.env.VUE_APP_API_ENDPOINT}/admin/api/v1/cms/payout/customer/downline/pagination-nocount`,
            {
              operator_id: store.state.selectedOperator.operatorId,
              type: "DOWNLINE",
              limit: rowsPerPage.value.value,
              offset: offset.value,
              search: searchInput.value,
            }
          )
          .then(({ data }) => {
            dataRows.value = data.data;
            dataCount.value = data.sum_data[0].total;
            isLoaded.value = true;
          })
          .catch((response) => { });
      } else refetch();
    };

    const refetch = (date) => {
      isLoaded.value = false;
      axios
        .post(
          `${process.env.VUE_APP_API_ENDPOINT}/admin/api/v1/cms/payout/customer/downline/pagination-nocount`,
          {
            operator_id: store.state.selectedOperator.operatorId,
            type: "DOWNLINE",
            limit: rowsPerPage.value.value,
            offset: offset.value,
            order_by: orderBy.value,
            search: searchInput.value || null,
            status:
              filterForm.value.status != "-SELECT STATUS-"
                ? filterForm.value.status
                : null,
          }
        )
        .then(({ data }) => {
          isLoaded.value = true;

          dataRows.value = data.data;
          dataCount.value = data.sum_data[0].total;
        })
        .catch(({ response }) => { });
    };

    const getLocaleDate = (date) => {
      return dayjs(date).locale("th").format("LLL");
    };

    const pageCount = (i) => {
      return Math.ceil(dataCount.value / rowsPerPage.value.value);
    };

    const paginationOffset = (i) => {
      return (parseInt(route.query.page) || 1) < 4
        ? i
        : parseInt(route.query.page) > Math.floor(dataCount.value / 10) - 3
          ? Math.floor(dataCount.value / 10) - 6 + i
          : route.query.page - 4 + i;
    };

    const prev = () => {
      // if (currentPage.value - 1 >= 1) {
      currentPage.value -= 1;
      offset.value = (currentPage.value - 1) * rowsPerPage.value.value;
      refetch();
      // }
    };

    const next = () => {
      // if (currentPage.value + 1 <= pageCount()) {
      offset.value = rowsPerPage.value.value * currentPage.value;

      refetch();
      currentPage.value += 1;
      // }
    };

    const jump = (page) => {
      currentPage.value = page;
      offset.value = (page - 1) * rowsPerPage.value.value;
      refetch();
    };

    const approvePayout = (id, status) => {
      isWorking.value = true;
      axios
        .post(
          `${process.env.VUE_APP_API_ENDPOINT}/admin/api/v1/cms/payout/customer/downline/approve`,
          {
            status: status,
            payout_id: id,
            remarks: status.toLowerCase().split("_").join("-"),
          }
        )
        .then(({ data }) => {
          isWorking.value = false;
          refetch();
        })
        .catch(({ response }) => {
          isWorking.value = false;
          alert("error mark as PAID");
        });
    };

    const filterData = (page = 0) => {
      hasError = false;

      if (page == 1) {
        //first time
        router.push({
          query: {
            page: 1,
          },
        });
      }
      currentPage.value = 1;
      offset.value = 0;
      axios
        .post(
          `${process.env.VUE_APP_API_ENDPOINT}/admin/api/v1/cms/payout/customer/downline/pagination-nocount`,
          {
            operator_id: store.state.selectedOperator.operatorId,
            type: "DOWNLINE",
            limit: rowsPerPage.value.value,
            offset: offset.value,
            order_by: orderBy.value,
            search: searchInput.value,
            status:
              filterForm.value.status != "-SELECT STATUS-"
                ? filterForm.value.status
                : null,
          }
        )
        .then(({ data }) => {
          dataRows.value = data.data;
          dataCount.value = data.sum_data[0].total;
          isLoaded.value = true;
          hasError = false;
        })
        .catch(({ response }) => {
          hasError = true;
          errorMessage = response;
        });
    };

    return {
      dataRows,
      dataCount,
      isLoaded,
      dayjs,
      searchInput,
      route,
      store,
      pageCount,
      paginationOffset,
      jump,
      prev,
      next,
      pages,
      getLocaleDate,
      approvePayout,
      currentDate,
      refetch,
      doSort,
      searchText,
      rowsPerPageOption,
      rowsPerPage,
      currentPage,
      offset,
      sort,
      isWorking,
      filterModal,
      advanceFilterModal,
      filterForm,
      status_list,
      errorMessage,
      hasError,
      buttonDropDownConfig,
    };
  },
};
</script>
<style scoped>
/* Add a simple spinner style without a background color */
.loader {
  border: 4px solid rgba(0, 0, 0, 0.1); 
  border-radius: 50%;
  border-top: 4px solid transparent; 
  width: 36px;
  height: 36px;
  -webkit-animation: spin 2s linear infinite;
  animation: spin 2s linear infinite;
}

@-webkit-keyframes spin {
  0% {
    -webkit-transform: rotate(0deg);
  }

  100% {
    -webkit-transform: rotate(360deg);
  }
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}
</style>